export default __webpack_public_path__ + "static/media/Boots of the Grand Monarch.228e215b.jpg";